import type { IconSvgObject } from './types';

const TickDouble02Icon: IconSvgObject = [
  ["path", { d: "M2 13.5L5.5 17.5L6.45455 16.5M16 6.5L10.75 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 13.5L11.5 17.5L22 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TickDouble02Icon;
